
import { useEffect, useState } from 'react';
import { validaLabelMenuDatas } from 'src/utils/functions';
import useAuth from 'src/hooks/useAuth';
import Iconify from 'src/components/Iconify';
import moment from 'moment';
import v2_actionConfigCrm from 'src/actions/v2/crm/v2_actionConfigCrm';
import actionListaClientesCanais from 'src/actions/clientes/actionListaClientesCanais';
import v2_action_crm_leadsPorUsuarios from 'src/actions/v2/dashboard/relatorios/v2_action_crm_leadsPorUsuarios';
import v2_actionInsightsExecutivo from 'src/actions/v2/dashboard/relatorios/v2_actionInsightsExecutivo';
import v2_actionGerarExcelRelatorioNegocios from 'src/actions/v2/dashboard/relatorios/excel/v2_actionGerarExcelRelatorioNegocios';
import v2_actionInsightsComercial from 'src/actions/v2/dashboard/relatorios/v2_actionInsightsComercial';
import v2_actionInsightsPerformance from 'src/actions/v2/dashboard/relatorios/v2_actionInsightsPerformance';
import MenuDatas2 from 'src/components/MenuDatas2';
import { SelectZui } from 'src/components/zui';
import { RowInput } from 'src/components/forms/RowInput';
import { SelectItem } from 'src/@/components/ui/select';
import { SkeletonChart } from 'src/@/components/use/skeleton/SkeletonChart';
import { GraficoCrmLeadsPorUsuarios } from '../charts/GraficoCrmLeadsPorUsuarios';
import { GraficoCrmOrigens } from '../charts/GraficoCrmOrigens';
import { GraficoCrmMotivoPerdas } from '../charts/GraficoCrmMotivoPerdas';
import { GraficoGanhosPerdas } from '../charts/GraficoGanhosPerdas';
import { GraficoNegociosGanhosPeriodo } from '../charts/GraficoNegociosGanhosPeriodo';
import { GraficoTotalGanhosPerdas } from '../charts/GraficoTotalGanhosPerdas';
import { GraficoConversaoLeads } from '../charts/GraficoConversaoLeads';
import { GraficoFunilConversao } from '../charts/GraficoFunilConversao';
import { GraficoConversaoEtapas } from '../charts/GraficoConversaoEtapas';
import { GraficoAgingEtapas } from '../charts/GraficoAgingEtapas';
import { GraficoDistribuicaoValor } from '../charts/GraficoDistribuicaoValor';
import { GraficoForecast } from '../charts/GraficoForecast';
import { GraficoConversaoAgentes } from '../charts/GraficoConversaoAgentes';
import WidgetLarge from 'src/components/_dashboard/relatorios/analitico/WidgetLarge';
import { Card, CardContent } from 'src/@/components/ui/card';

export default function TabCrm({ clienteId, periodo, changeClienteId, changePeriodo, campaingConfig, hidePannels }) {
    const { user, cliente } = useAuth();
    const [inicial, setInicial] = useState(new Date());
    const [final, setFinal] = useState(new Date());
    const [metricasTrocaMensagens, setMetricasTrocaMensagens] = useState([]);
    const [metricasOrigens, setMetricaOrigens] = useState([]);
    const [metricasGanhosPerdas, setMetricaGanhosPerdas] = useState([]);
    const [motivosPerdas, setMotivoPerdas] = useState([]);
    const [conversaoEstagios, setConversaoEstagios] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenuDatas = Boolean(anchorEl);
    const inicio2 = moment(inicial).format("YYYY-MM-DD");
    const final2 = moment(final).format("YYYY-MM-DD");
    const [listaClientesCanais, setListaClientesCanais] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pipelineId, setPipelineId] = useState('');
    const [configCrm, setConfigCrm] = useState({});
    const [totais, setTotais] = useState(null);
    const [negociosUsuarios, setNegociosUsuarios] = useState([]);
    const [insightsExec, setInsightsExec] = useState(null);
    const [loadingInsights, setLoadingInsights] = useState(false);
    const [loadingExportExcel, setLoadingExportExcel] = useState(false);
    const [loadingComercial, setLoadingComercial] = useState(false);
    const [comercialData, setComercialData] = useState(null);
    const [loadingFunil, setLoadingFunil] = useState(false);
    const [funilData, setFunilData] = useState(null);
    const [conversaoPorAgente, setConversaoPorAgente] = useState([]);

    const buscarDataPipiline = async (value, clienteId, pipelineId) => {
        try {
            setLoading(true);
            let startDate = campaingConfig?.start_date ? campaingConfig.start_date : inicio2;
            let endDate = campaingConfig?.end_date ? campaingConfig.end_date : final2;
            let querys = `?pipeline_id=${pipelineId}&usuario_id=${user.id}&cliente_id=${clienteId}&inicio=${startDate}&final=${endDate}`;
            querys += `&periodo=${campaingConfig?.periodo ? 'null' : value}`
            if (campaingConfig) {
                querys += `&campaign_id=${campaingConfig.campaign_id}`
            }
            const res = await v2_action_crm_leadsPorUsuarios(querys);
            setMetricasTrocaMensagens(res.data.data.leads_usuarios);
            setMetricaOrigens(res.data.data.origens);
            setMetricaGanhosPerdas(res.data.data.ganhosPerdas);
            setMotivoPerdas(res.data.data.motivosPerdas);
            setConversaoEstagios(res.data.data.conversaoEstagios);
            setTotais(res.data.data.totais);
            setNegociosUsuarios(res.data.data.negociosUsuarios);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    async function buscarInsightsExecutivo(pid) {
        try {
            setLoadingInsights(true);
            const querys = `?cliente_id=${cliente._id}&periodo=${periodo}&inicio=${inicio2}&final=${final2}&usuario_id=${user.id}&pipeline_id=${pid || pipelineId}`;
            const res = await v2_actionInsightsExecutivo(querys);
            setInsightsExec(res.data.data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingInsights(false);
        }
    }

    const fetchComercial = async (pid) => {
        try {
            setLoadingComercial(true);
            const currentPid = pid || pipelineId;
            if (!currentPid) return;
            const querys = `?cliente_id=${clienteId}&periodo=${periodo}&inicio=${inicio2}&final=${final2}&usuario_id=${user.id}&pipeline_id=${currentPid}`;
            const res = await v2_actionInsightsComercial(querys);
            setComercialData(res.data.data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingComercial(false);
        }
    }

    const fetchFunil = async (pid) => {
        try {
            setLoadingFunil(true);
            const currentPid = pid || pipelineId;
            const querys = `?cliente_id=${clienteId}&periodo=${periodo}&inicio=${inicio2}&final=${final2}&usuario_id=${user.id}&pipeline_id=${currentPid}`;
            const [resExec, resPerf] = await Promise.all([
                v2_actionInsightsExecutivo(querys),
                v2_actionInsightsPerformance(querys),
            ]);
            setFunilData(resExec.data.data);
            setConversaoPorAgente(resPerf.data.data?.conversaoPorAgente || []);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingFunil(false);
        }
    }

    const handleExportToExcel = async () => {
        try {
            setLoadingExportExcel(true);
            const querys = `?periodo=${periodo}&usuario_id=${user.id}&cliente_id=${cliente._id}&data_inicial=${inicio2}&data_final=${final2}&pipeline_id=${pipelineId}`;
            const response = await v2_actionGerarExcelRelatorioNegocios(querys);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `negocios_${new Date().toISOString().split('T')[0]}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.log('Erro ao exportar negócios:', error);
        } finally {
            setLoadingExportExcel(false);
        }
    };

    async function buscarConfigCrm(querys) {
        try {
            const result = await v2_actionConfigCrm(cliente._id, querys);
            if (result.data.data) {
                let data = result.data.data;
                if (data.pipelines.length > 0) {
                    const pid = data.pipelines[0]._id;
                    setPipelineId(pid);
                    buscarDataPipiline(periodo, cliente._id, pid);
                    buscarInsightsExecutivo(pid);
                    fetchComercial(pid);
                    fetchFunil(pid);
                }
                setConfigCrm(result.data.data);
            }
        } catch (error) {
        }
    }

    async function buscarListaClientesCanais() {
        try {
            const response_clientes_canais = await actionListaClientesCanais(cliente._id)
            setListaClientesCanais(response_clientes_canais.data.data);
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        buscarConfigCrm();
        if (cliente.multiSession === 1) {
            buscarListaClientesCanais()
        }
    }, [inicial, final, periodo]);

    const handlePesquisar = async (periodo) => {
        const promises = [
            changePeriodo('null'),
            buscarDataPipiline(periodo),
        ];
        await Promise.all(promises);
    }

    const formatCurrency = (value) => {
        if (!value) return 'R$ 0';
        return `R$ ${Number(value).toLocaleString('pt-BR')}`;
    };

    return (
        <div className="mb-5 animate-in fade-in slide-in-from-bottom-4 duration-500">

            <div className="flex flex-col sm:flex-row items-start sm:items-end gap-4 mt-5">
                {!campaingConfig && (
                    <RowInput
                        label="período"
                        value={cliente._id}
                        input={<MenuDatas2
                            anchorEl={anchorEl}
                            open={openMenuDatas}
                            onClose={() => setAnchorEl(false)}
                            inicial={inicial}
                            final={final}
                            changeInicial={newValue => setInicial(newValue)}
                            changeFinal={newValue => { setFinal(newValue) }}
                            content={validaLabelMenuDatas(periodo, inicial, final)}
                            onSelect={value => {
                                changePeriodo(value);
                                setAnchorEl(null);
                            }}
                            onPesquisar={() => {
                                handlePesquisar("null")
                            }}
                        />}
                    />
                )}

                <RowInput
                    sx={{ width: '100%' }}
                    label="funil"
                    input={<SelectZui
                        value={pipelineId}
                        list={configCrm?.pipelines}
                        onChange={e => {
                            let value = e;
                            setPipelineId(value);
                            buscarDataPipiline(periodo, cliente._id, value);
                            buscarInsightsExecutivo(value);
                            fetchComercial(value);
                            fetchFunil(value);
                        }}
                        itemSelect={(item) => (
                            <SelectItem key={item._id} value={item._id}>
                                {item.nome}
                            </SelectItem>
                        )}
                    />}
                />

                <button
                    onClick={handleExportToExcel}
                    disabled={loadingExportExcel}
                    className="h-9 self-end flex items-center gap-2 px-4 rounded-lg border border-dashed border-gray-300 hover:border-green-500 hover:text-green-600 hover:bg-green-50 text-gray-600 bg-transparent transition-colors text-sm font-medium whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {loadingExportExcel ? <Iconify icon="mdi:loading" className="animate-spin h-4 w-4" /> : <Iconify icon="file-icons:microsoft-excel" className="h-4 w-4" />}
                    Exportar Excel
                </button>
            </div>

            {/* Widgets - Linha 1: 3 cols + Linha 2: 4 cols */}
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 mt-6">
                <WidgetLarge loading={loadingInsights} title="Negócios Criados" total={insightsExec?.leadsCriados || 0} icon="mdi:account-plus" iconColor="purple" tooltip="Total de leads criados no periodo selecionado" />
                <WidgetLarge
                    loading={loading}
                    title="Negócios em aberto"
                    total={`${totais?.quantidade_abertos ? totais?.quantidade_abertos?.total_abertos.toFixed(0) : 0}`}
                    icon="mdi:account-funnel-outline"
                    iconColor="green"
                    tooltip="Negocios que ainda estao em andamento no funil"
                />
                <WidgetLarge
                    loading={loading}
                    title="Negócios finalizados"
                    total={`${totais?.quantidade_finalizados ? totais?.quantidade_finalizados?.total_finalizados.toFixed(0) : 0}`}
                    icon="mdi:funnel-remove-outline"
                    iconColor="red"
                    tooltip="Total de negocios finalizados (ganhos ou perdidos) no periodo"
                />
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-3">
                <WidgetLarge
                    loading={loading}
                    title="Média duração"
                    total={`${totais?.media_duracao ? totais?.media_duracao?.media_duracao.toFixed(0) : 0}d`}
                    icon="mdi:clock-outline"
                    iconColor="blue"
                    tooltip="Tempo medio em dias entre a criacao e o fechamento dos negocios"
                />
                <WidgetLarge loading={loadingInsights} title="Qualificados" total={insightsExec?.leadsQualificados || 0} icon="mdi:account-check" iconColor="green" tooltip="Leads que avancaram alem da primeira etapa do funil" />
                <WidgetLarge loading={loadingInsights} title="Perdidos" total={insightsExec?.leadsPerdidos || 0} icon="mdi:account-remove" iconColor="red" tooltip="Leads marcados como perdidos no periodo" />
                <WidgetLarge loading={loadingInsights} title="Conversão %" total={`${insightsExec?.taxaConversao || 0}%`} icon="mdi:percent" iconColor="indigo" tooltip="Percentual de leads ganhos sobre o total de leads fechados (ganhos + perdidos)" />
            </div>

            <div className="border-t border-dashed border-gray-200 my-6" />

               {/* Comercial - Widgets */}
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
                <WidgetLarge loading={loadingComercial} title="Pipeline Aberto" total={formatCurrency(comercialData?.pipelineAberto?.valor)} icon="mdi:funnel" iconColor="purple" tooltip="Valor total dos negocios em aberto no funil selecionado" />
                <WidgetLarge loading={loadingComercial} title="Ganhos" total={formatCurrency(comercialData?.ganhos?.valor)} icon="mdi:trophy" iconColor="green" tooltip="Valor total dos negocios ganhos (convertidos) no periodo" />
                <WidgetLarge loading={loadingComercial} title="Perdidos" total={formatCurrency(comercialData?.perdidos?.valor)} icon="mdi:close-circle" iconColor="red" tooltip="Valor total dos negocios perdidos no periodo" />
            </div>
            <div className="grid grid-cols-4 lg:grid-cols-4 gap-3 mt-3">
                <WidgetLarge loading={loadingComercial} title="Win Rate" total={`${comercialData?.winRate || 0}%`} icon="mdi:chart-arc" iconColor="green" tooltip="Taxa de vitoria: negocios ganhos dividido pelo total de fechados (ganhos + perdidos)" />
                <WidgetLarge loading={loadingFunil} title="Receita Potencial" total={`R$ ${(funilData?.receitaPotencial || 0).toLocaleString('pt-BR')}`} icon="mdi:currency-brl" iconColor="green" tooltip="Soma dos valores de todos os leads ainda em aberto no funil" />
                <WidgetLarge loading={loadingComercial} title="Ciclo Médio" total={`${comercialData?.cicloMedio || 0} dias`} icon="mdi:calendar-clock" iconColor="indigo" tooltip="Tempo medio em dias entre a criacao e o fechamento dos negocios ganhos" />
                <WidgetLarge loading={loadingComercial} title="Ticket Médio" total={formatCurrency(comercialData?.ticketMedio)} icon="mdi:cash" iconColor="purple" tooltip="Valor medio dos negocios ganhos no periodo" />
            </div>

            

            {/* Gráficos - Leads por Usuários + Origens */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-6">
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loading ? <SkeletonChart /> : (
                        <GraficoCrmLeadsPorUsuarios chartData={metricasTrocaMensagens} />
                    )}
                </div>
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loading ? <SkeletonChart /> : (
                        <GraficoCrmOrigens chartData={metricasOrigens} />
                    )}
                </div>
            </div>

            {/* Conversão de Leads (full width) */}
            <div className="mt-4">
                {loading ? <SkeletonChart /> : (
                    <GraficoConversaoLeads chartData={conversaoEstagios} />
                )}
            </div>

            {/* Ganhos/Perdas + Funil Conversão */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loading ? <SkeletonChart /> : (
                        <GraficoGanhosPerdas chartData={metricasGanhosPerdas} />
                    )}
                </div>
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loading ? <SkeletonChart /> : (
                        <GraficoFunilConversao chartData={conversaoEstagios} />
                    )}
                </div>
            </div>

            {/* Motivo Perdas + Total Ganhos/Perdas */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loading ? <SkeletonChart /> : (
                        <GraficoCrmMotivoPerdas chartData={motivosPerdas} />
                    )}
                </div>
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loading ? <SkeletonChart /> : (
                        <GraficoTotalGanhosPerdas
                            chartData={[
                                { tipo: "perda", total: totais?.totalPerdido || 0, fill: '#ff5f5f' },
                                { tipo: "ganho", total: totais?.totalGanho || 0, fill: '#DACFFB' },
                            ]}
                        />
                    )}
                </div>
            </div>

            {/* Negócios Ganhos por Período (full width) */}
            {!hidePannels?.includes('last_6_months') && (
                <div className="mt-4">
                    {loading ? <SkeletonChart /> : (
                        <GraficoNegociosGanhosPeriodo chartData={negociosUsuarios} />
                    )}
                </div>
            )}

            <div className="border-t border-dashed border-gray-200 my-6" />

         

            {/* Comercial - Gráficos */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loadingComercial ? <SkeletonChart /> : (
                        <GraficoConversaoEtapas chartData={comercialData?.conversaoPorEtapa || []} />
                    )}
                </div>
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loadingComercial ? <SkeletonChart /> : (
                        <GraficoAgingEtapas chartData={comercialData?.tempoPorEtapa || []} />
                    )}
                </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loadingComercial ? <SkeletonChart /> : (
                        <GraficoDistribuicaoValor chartData={comercialData?.distribuicaoFaixaValor || []} />
                    )}
                </div>
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loadingComercial ? <SkeletonChart /> : (
                        <GraficoForecast provavel={comercialData?.forecastProvavel || 0} conservador={comercialData?.forecastConservador || 0} />
                    )}
                </div>
            </div>

            <div className="border-t border-dashed border-gray-200 my-6" />

            {/* Funil - Widget + Gráficos */}
   
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                <div className="min-h-[300px] max-h-[420px]">
                    {funilData?.gargalo ? (
                        <Card className="h-full">
                            <CardContent className="p-6 flex flex-col justify-center h-full">
                                <p className="text-sm font-medium text-gray-500 mb-2">Gargalo Atual</p>
                                <p className="text-2xl font-bold text-gray-900">{funilData.gargalo.estagio}</p>
                                <div className="flex gap-4 mt-3">
                                    <div>
                                        <p className="text-xs text-gray-500">Negócios</p>
                                        <p className="text-lg font-semibold">{funilData.gargalo.count}</p>
                                    </div>
                                    <div>
                                        <p className="text-xs text-gray-500">Idade média</p>
                                        <p className="text-lg font-semibold">{funilData.gargalo.avgAge}d</p>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    ) : (
                        loadingFunil ? <SkeletonChart /> : (
                            <Card className="h-full">
                                <CardContent className="p-6 flex items-center justify-center h-full">
                                    <p className="text-sm text-gray-500">Nenhum gargalo identificado</p>
                                </CardContent>
                            </Card>
                        )
                    )}
                </div>
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loadingFunil ? <SkeletonChart /> : (
                        <GraficoConversaoAgentes chartData={conversaoPorAgente} />
                    )}
                </div>
            </div>
        </div>
    );
}
